export default __webpack_public_path__ + "static/media/credpallogo2.ca2398fa.svg";